// imports
import Component from 'minsky-kit/js/components/Component';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

// private statics

// class definition

export default class InviewManager extends Component {
    // constructor
    constructor(args = {}, objectName = 'InviewManager') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        // register gsp plugins
        gsap.registerPlugin(ScrollTrigger);

        // set properties
        this.$el = args.$el;
        this.$page = document.querySelector('.page');

        // init timeline
        this._inviewAnimation = new gsap.timeline({
            autoRemoveChildren: true
        });

        // add main inview animation
        this._inviewAnimation.fromTo(
            this.$el,
            {
                y: 25,
                opacity: 0,
            },
            {
                y: 0,
                opacity: 1,
                duration: 0.35,
            }, 0
        );

        // check if it needs to count up
        Array.from(this.$el.querySelectorAll('.js-count-animation')).forEach($item => {

            switch ($item.dataset.animType) {
                case 'count-up':
                    const number = $item.innerText.replace(',', '');
                    const counter = { value: number / 2 }
                    this._inviewAnimation.to(counter, {
                        value: number * 1,
                        duration: 2,
                        ease: 'power2.out',
                        onUpdate: onCountUpUpdate,
                        onUpdateParams: [$item, counter],
                        onComplete: onCountUpUpdate,
                        onCompleteParams: [$item, counter]
                    }, 0)
                    break;

                default:
                    this.log('warn', 'any other type of count animation still needs to be developed');
            }
        });


        // scrolltrigger
        this._trigger = ScrollTrigger.create({
            markers: false,
            trigger: this.$el,
            start: `top 90%`,
            animation: this._inviewAnimation,
        });

        let resizeObserver = new ResizeObserver(() => {
            this._trigger.refresh();
        });

        resizeObserver.observe(this.$page);
    }

    // methods
    destroy() {
        this._trigger.kill(true);

        // super destroy
        super.destroy();
    }
    // getters & setters
}

// Utils

// Event handlers
function onCountUpUpdate($el, counter) {
    // console.log(counter);
    $el.innerText = Math.round(counter.value * 10) / 10;
}
